<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Manage Docusign Templates</div>
    </div>
    <mat-divider></mat-divider>
    <div class="subtitle-row">
      <button color="primary" mat-stroked-button (click)="addNew()">Add New Template</button>
    </div>
    <mat-divider></mat-divider>
    <div class="table-container">
      <table [dataSource]="dataSource" mat-table aria-describedby="Docusign Template List">
        <ng-container matColumnDef="actions">
          <th scope="col" *matHeaderCellDef mat-header-cell>Actions</th>
          <td *matCellDef="let element" class="action-cell" mat-cell>
            <div (click)="clickRow(element)" class="edit-icon">
              <fa-icon title="Edit Document" [icon]="['far', 'edit']" class="blue size-18"></fa-icon>
            </div>
            <div (click)="deleteTemplate(element)" class="delete-icon">
              <fa-icon title="Delete Document" [icon]="['far', 'trash']" class="gray delete-icon size-18"></fa-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th scope="col" *matHeaderCellDef mat-header-cell class="small-column">Template Description</th>
          <td *matCellDef="let row" class="description" mat-cell>
            {{ row.description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="buyer">
          <th scope="col" *matHeaderCellDef mat-header-cell class="medium-column">
            <span>Buyer</span>
            <mat-form-field class="buyer-filter-select">
              <mat-label>Buyer Filter</mat-label>
              <mat-select (selectionChange)="getItemByBuyerId($event, 'buyer_id')">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let buyer of buyers" [value]="buyer.id">
                  {{ buyer.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>{{ row.buyer.name }}</td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>
  </div>
</div>
